module.exports = __webpack_public_path__ + "media/top/icon_location-b9e8fb19.svg";